/**
 * Uploading and referencing attached files.
 *
 * Uploads go through postMultipart, not a plain post: axios needs the browser to
 * set the multipart boundary itself, and a hand-set Content-Type silently breaks
 * the request in a way no backend test can see.
 */
import api, { getErrorMessage, postMultipart } from './api'
import type { StoredFileInfo } from '../types'

export async function uploadFile(
  file: File,
  opts?: {
    clientId?: number
    leadId?: number
    slotLabel?: string
    retentionDays?: number
    permanent?: boolean
  }
): Promise<StoredFileInfo> {
  const form = new FormData()
  form.append('file', file)
  if (opts?.clientId) form.append('client_id', String(opts.clientId))
  if (opts?.leadId) form.append('lead_id', String(opts.leadId))
  if (opts?.slotLabel) form.append('slot_label', opts.slotLabel)
  if (opts?.retentionDays) form.append('retention_days', String(opts.retentionDays))
  if (opts?.permanent) form.append('permanent', 'true')

  try {
    const response = await postMultipart<StoredFileInfo>('/v1/files', form)
    return response.data
  } catch (error) {
    throw new Error(getErrorMessage(error))
  }
}

export async function deleteFile(fileId: number): Promise<void> {
  try {
    await api.delete(`/v1/files/${fileId}`)
  } catch (error) {
    throw new Error(getErrorMessage(error))
  }
}

/** Where the browser should point to download a stored file. */
export function fileDownloadUrl(fileId: number): string {
  return `/api/v1/files/${fileId}/download`
}
